import React from 'react';
import styled from 'styled-components';
import { UploadGlyph } from './glyphs';
import { tok } from './styles';

/**
 * Page header for un-bulk-upload — mirrors the live sandbox's lum page header
 * (not the DS `PageHeader`, whose avatar slot is circular + icon-font only):
 * a 72×72 rounded icon box with the upload glyph, the title (32/700), a bold
 * subtitle and a full-width divider underneath. Shared by both flow states.
 */
const Wrap = styled.div`
  margin-bottom: 44px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const IconBox = styled.div`
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => tok(theme, 'avatar_icon_background', '#F4F4F4')};
  color: ${({ theme }) => tok(theme, 'avatar_icon_icon', '#1E1E1E')};
`;

const Title = styled.h1`
  margin: 0;
  font-size: 32px;
  line-height: 40px;
  font-weight: 700;
  color: ${({ theme }) => tok(theme, 'general_font_primary', '#1E1E1E')};
`;

const Subtitle = styled.div`
  margin-top: 8px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: ${({ theme }) => tok(theme, 'general_font_primary', '#1E1E1E')};
`;

const Divider = styled.div`
  margin-top: 24px;
  border-bottom: 1px solid ${({ theme }) => tok(theme, 'containers_bordered_border', '#DADADA')};
`;

export type FlowHeaderProps = { title: string; subtitle?: string };

export const FlowHeader: React.FC<FlowHeaderProps> = ({ title, subtitle }) => (
  <Wrap>
    <Row>
      <IconBox>
        <UploadGlyph size={28} color="currentColor" />
      </IconBox>
      <div>
        <Title>{title}</Title>
        {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
      </div>
    </Row>
    <Divider />
  </Wrap>
);
